"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents the strategy to clear the format of the current editor selection
 */
var ClearFormatMode;
(function (ClearFormatMode) {
    /**
     * Inline format. Remove text format.
     */
    ClearFormatMode[ClearFormatMode["Inline"] = 0] = "Inline";
    /**
     * BLock format. Remove text and structure format of the block.
     */
    ClearFormatMode[ClearFormatMode["Block"] = 1] = "Block";
    /**
     * Detect Inline or Block format based on the current editor selectior.
     */
    ClearFormatMode[ClearFormatMode["AutoDetect"] = 2] = "AutoDetect";
})(ClearFormatMode = exports.ClearFormatMode || (exports.ClearFormatMode = {}));
//# sourceMappingURL=ClearFormatMode.js.map